import { PropTypes } from "@material-ui/core";

export const fieldMargin: PropTypes.Margin = "normal";
export const gridFieldMargin: PropTypes.Margin = "normal";
export const compactGridFieldMargin: PropTypes.Margin = "dense";